<div class="nav-pills">
    @for (category of config().isTouch ? navItems() : processedMyNavCategories(); track $index) {
        @if (category.isNavigationCategory) {
            <div #pillRef class="pill-item" [id]="category.categoryid" [hidden]="isHidden(category.categoryid)" [class]="category.classMap">
                <cc-pill-item
                    [config]="config()"
                    [item]="category"
                    [isSelected]="isSelected(category)"
                    [iconName]="category.sitecoreData.attributes.icon"
                    [currentTheme]="currentTheme()"
                    (onPillClick)="onPillClick(category, $event)">
                </cc-pill-item>
            </div>
        }
    }
</div>
